import React, { useState, useContext } from "react";
import axiosClient from "../../config/axios";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import AttachmentOutlinedIcon from "@material-ui/icons/AttachmentOutlined";
import InputAdornment from "@material-ui/core/InputAdornment";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import CircularProgress from "@material-ui/core/CircularProgress";

import AlertMui from "./AlertMui";

import AlertContext from "../../context/alert/alertContext";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "400px",
    },
  },
  input: {
    display: "none",
  },
}));

export default function UploadFileMui(props) {
  const alertContext = useContext(AlertContext);
  const { alert, showAlert } = alertContext;
  const { closeModal, type } = props;
  const [file, setFile] = useState(null);
  const [filename, setFileName] = useState(null);
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const classes = useStyles();

  const onChange = (e) => {
    setFile(e.target.files[0]);
    setFileName(e.target.files[0].name);
  };

  const onChangePassword = (e) => {
    setPassword(e.target.value);
  };

  const cleanFile = () => {
    setFile(null);
    setFileName(null);
  };

  const uploadFile = async (e) => {
    setLoading(true);
    e.preventDefault();

    if (type !== "caf") {
      if (!file || !password) {
        showAlert("El archivo y la contraseña son obligatorios", "warning");
        return;
      }
    }

    if (!file) {
      showAlert("El archivo es obligatorio", "warning");
      return;
    }

    //pasar archivo a form data
    const data = new FormData();
    const fileData = file;
    data.append("file", fileData);

    const typeFile =
      type === "caf"
        ? "/uploadcaffile"
        : `/uploadpfxcertificatefile/${password}`;

    try {
      const response = await axiosClient({
        method: "POST",
        url: typeFile,
        data: data,
      });

      setPassword("");
      if (response.status === 200) {
        showAlert(response.data.msg, "success");
      }

      setTimeout(() => {
        setLoading(false)
        handleCloseModal();
      }, 3000);
    } catch (error) {
      if (error.response) {
        if (error.response.status === 400) {
          showAlert(error.response.data.msg, "error");
          setLoading(false)
          return;
        }
      }
      setPassword("");
      showAlert(
        type !== "caf"
          ? "La contraseña no corresponde"
          : "El archivo ya existe en la plataforma",
        "error"
      );
    }
    setLoading(false);
  };

  const handleCloseModal = () => {
    cleanFile();
    closeModal();
  };

  return (
    <div style={{ width: "550px" }}>
      <Box display="flex" p={1} bgcolor="background.paper">
        <Box p={1} width="100%" style={{ display: "flex" }}>
          <form style={{ width: "100%" }} onSubmit={uploadFile}>
            <div style={{ width: "100%", display: "flex" }}>
              <input
                accept={type === "caf" ? "text/xml" : "text/pfx"}
                className={classes.input}
                id="contained-button-file"
                name="contained-button-file"
                type="file"
                onChange={onChange}
                onClick={(event) => {
                  event.target.value = null;
                }}
              />
              <label htmlFor="contained-button-file" style={{ margin: "auto" }}>
                <Button variant="contained" color="primary" component="span">
                  Seleccionar archivo
                </Button>
              </label>
              <Box
                p={1}
                flexShrink={0}
                style={{ width: "30px", margin: "auto" }}
              >
                <DeleteOutlineOutlinedIcon onClick={cleanFile} />
              </Box>
              <Box p={1} flexShrink={0} style={{ width: "30%" }}>
                {type !== "caf" && (
                  <TextField
                    margin="normal"
                    fullWidth
                    name="password"
                    label="CONTRASEÑA"
                    type="password"
                    id="password"
                    autoComplete="current-password"
                    style={{ fontSize: "14px", margin: "auto" }}
                    InputLabelProps={{ style: { fontSize: "14px" } }}
                    InputProps={{
                      style: { fontSize: "14px" },
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockOutlinedIcon
                            style={{
                              color: "#12b1ee",
                            }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    value={password}
                    onChange={onChangePassword}
                  />
                )}
              </Box>
            </div>
            <Box
              p={1}
              style={{
                display: "flex",
                alignItems: "center",
                marginLeft: "20px",
              }}
            >
              {filename && (
                <>
                  <AttachmentOutlinedIcon />
                  <p>{filename}</p>
                </>
              )}
            </Box>
          </form>
        </Box>
      </Box>
      {alert && <AlertMui message={alert.msg} type={alert.category} />}
      <Box style={{ float: "right" }}>
        {" "}
        {loading ? (
          <CircularProgress />
        ) : (
          <Button onClick={uploadFile} style={{ color: "#006400" }}>
            Guardar
          </Button>
        )}
        <Button onClick={handleCloseModal} color="primary">
          Salir
        </Button>
      </Box>
    </div>
  );
}
